<template>
  <section class="content-plans-register">
    <Breadcrumb :links="links" :data="this.dataProps" />
    <form class="content-plans-register-form" @submit.prevent="handleSubmit()">
      <div class="row">
        <div class="col-12">
          <div class="content-input-default">
            <input
              type="text"
              name="name"
              v-model="position.name"
              value=""
              placeholder="Nome"
              required
            />
          </div>
        </div>
        <div class="col-12">
          <button class="btn-green">Salvar</button>
        </div>
      </div>
    </form>
  </section>
</template>

<script>
import Breadcrumb from "@/components/breadcrumb/Index";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      links: [
        {
          name: "Empresas",
          routerName: "Company",
        },
        {
          name: "Novo Cargo",
          routerName: "RegisterPosition",
        },
      ],
      position: {
        name: "",
      },
      positionParams: this.$route.params,
      dataProps: { module: "Company" },
    };
  },
  computed: {
    ...mapGetters({
      user: "User/user",
      positionsData: "Company/positions",
    }),
  },
  components: {
    Breadcrumb,
  },
  methods: {
    ...mapActions("Company", [
      "registerPositions",
      "consultPositions",
      "setDataDefault",
    ]),
    async handleSubmit() {
      let message = this.position?.id
        ? "Cargo editado com sucesso!"
        : "Cargo cadastrado com sucesso!";

      await this.registerPositions(this.position);
      this.$router.push({ name: "ListPositions" });
      this.$swal.fire({
        icon: "success",
        html: message,
      });
    },
  },
  async mounted() {
    if (this.positionParams && Object.keys(this.positionParams).length > 0) {
      await this.consultPositions(this.positionParams);
      this.dataProps = {
        name: this.positionsData.name,
        id: this.positionParams.id,
        module: "Company",
        type: "Position",
      };
      this.position = this.positionsData;
      this.links[1].name = this.position.name;
    }
  },
};
</script>

<style lang="scss" scoped>
.content-plans-register {
  padding-bottom: 50px;
}
.content-input-default {
  textarea {
    min-height: 250px;
  }
}
.btn-green {
  margin-top: 100px;
  @media (max-width: 991px) {
    margin-top: 50px;
  }
}
</style>
